/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 * FREE GIFT FUNCTIONALITY:
 * - 1 bottle selected: Includes "RESET YOUR BODY IN 14 DAYS" ebook (Product ID: 8107949621385)
 * - 2 bottles selected: Includes "EVOLV Charging Block" (Product ID: 7822945157257)
 * - 3+ bottles selected: Includes "EVOLV Food-Grade Compression Seal" (Product ID: 7654294388873)
 * 
 * Free gifts are automatically added to the cart during checkout based on the total
 * quantity of bottles selected across all variants.
 */

(function () {
  'use strict';

  // Pricing config (kept in cents to avoid floating rounding issues)
  const PRICING_CONFIG = {
    SUBSCRIPTION_DISCOUNT_PERCENT: 75, // 25% off => pay 75%
    FLAT_DISCOUNT_PER_UNIT_CENTS: {
      1: 0,
      2: 500,
      3: 700
    }
  };

  function getOfferContainer() {
    return document.querySelector('[data-offer-1-container]');
  }

  function getCurrencyCode() {
    const offerContainer = getOfferContainer();
    return offerContainer?.dataset?.currency || 'USD';
  }

  function formatMoneyFromCents(cents) {
    const currency = getCurrencyCode();
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      // Fallback if currency code is invalid / Intl unavailable
      return `$${amount.toFixed(2)}`;
    }
  }

  function getBaseUnitPriceCents() {
    const offerContainer = getOfferContainer();
    const fromDataAttr = parseInt(offerContainer?.dataset?.basePriceCents || '', 10);
    if (Number.isFinite(fromDataAttr) && fromDataAttr > 0) return fromDataAttr;

    // Fallback: first variant price (if present)
    const firstVariantBtn = document.querySelector('[data-variant-price]');
    const fallback = parseInt(firstVariantBtn?.getAttribute('data-variant-price') || '', 10);
    return Number.isFinite(fallback) && fallback > 0 ? fallback : 0;
  }

  function getFlatDiscountPerUnitCents(quantity) {
    const qty = Number(quantity) || 0;
    if (qty >= 3) return PRICING_CONFIG.FLAT_DISCOUNT_PER_UNIT_CENTS[3];
    if (qty === 2) return PRICING_CONFIG.FLAT_DISCOUNT_PER_UNIT_CENTS[2];
    return PRICING_CONFIG.FLAT_DISCOUNT_PER_UNIT_CENTS[1];
  }

  function applyDiscountsToUnitPriceCents(unitPriceCents, quantity, isSubscription) {
    let cents = Number(unitPriceCents) || 0;

    // Step 1: subscription discount (percentage) first
    if (isSubscription) {
      cents = Math.round((cents * PRICING_CONFIG.SUBSCRIPTION_DISCOUNT_PERCENT) / 100);
    }

    // Step 2: flat discount per unit based on quantity tier
    cents -= getFlatDiscountPerUnitCents(quantity);

    return Math.max(0, Math.round(cents));
  }

  function calculateTotalPriceCentsFromUnit(unitPriceCents, quantity, isSubscription) {
    const qty = Number(quantity) || 0;
    const perUnit = applyDiscountsToUnitPriceCents(unitPriceCents, qty, isSubscription);
    return perUnit * qty;
  }

  // Helper function to check if subscription is selected
  function isSubscriptionSelected() {
    const subscriptionSelection = document.querySelector('[data-subscription-selection]');
    if (subscriptionSelection) {
      const selectedSubscription = subscriptionSelection.querySelector('input[name="subscription-type"]:checked');
      return selectedSubscription && selectedSubscription.value === 'subscribe';
    }
    return false;
  }

  // Global function to update all pricing displays
  function updateAllPricingDisplays() {
    const baseUnitPriceCents = getBaseUnitPriceCents();

    // Get the selected quantity
    const selectedQuantityButton = document.querySelector('.quantity-selector__card[aria-selected="true"]');
    const selectedQuantity = selectedQuantityButton ? parseInt(selectedQuantityButton.getAttribute('data-offer-qty'), 10) || 3 : 3;

    // Update the visible per-unit prices in the quantity selector cards
    const qtyCards = document.querySelectorAll('.quantity-selector__card[data-offer-qty]');
    qtyCards.forEach((card) => {
      const qty = parseInt(card.getAttribute('data-offer-qty'), 10);
      const bottlePriceEl = card.querySelector('.bottle-price');
      if (!bottlePriceEl || !Number.isFinite(qty)) return;

      const perUnitCents = applyDiscountsToUnitPriceCents(baseUnitPriceCents, qty, false);
      // Keep the existing "/each" or "/ea" suffix style consistent with Liquid
      bottlePriceEl.textContent = `${formatMoneyFromCents(perUnitCents)}/each`;
    });

    // Update all price comparison elements
    const allPriceComparisons = document.querySelectorAll('[data-price-comparison]');
    allPriceComparisons.forEach(priceComparison => {
      console.log(priceComparison)
      console.log('value: ', priceComparison.dataset.priceComparison)
      const originalPrice = priceComparison.querySelector('.original-price');
      const discountedPrice = priceComparison.querySelector('.discounted-price');
      
      if (originalPrice && discountedPrice) {
        const originalPerBottleCents = baseUnitPriceCents;
        originalPrice.textContent = formatMoneyFromCents(originalPerBottleCents);
        
        if (priceComparison.dataset.priceComparison === 'subscription') {
          console.log('changing subscription price')
          // Subscription pricing: calculate per-bottle price, not total
          const discountedPerBottleCents = applyDiscountsToUnitPriceCents(originalPerBottleCents, selectedQuantity, true);
          discountedPrice.textContent = `${formatMoneyFromCents(discountedPerBottleCents)}/ea`;
        } else if (priceComparison.dataset.priceComparison === 'one-time') {
          console.log('changing one time price')
          // One-time pricing: calculate per-bottle price, not total
          const discountedPerBottleCents = applyDiscountsToUnitPriceCents(originalPerBottleCents, selectedQuantity, false);
          discountedPrice.textContent = formatMoneyFromCents(discountedPerBottleCents);
          if (originalPerBottleCents === discountedPerBottleCents) {
            originalPrice.classList.add('hidden');
          } else {
            originalPrice.classList.remove('hidden');
          }
        } else if(priceComparison.dataset.priceComparison === '') {
          console.log('changing select colors price')
          // SELECT COLORS button should change based on current selection
          const subscriptionSelection = document.querySelector('input[name="subscription-type"]:checked');
          const selectedValue = subscriptionSelection ? subscriptionSelection.value : 'subscribe';
          
          // Calculate original total based on base unit price and selected quantity
          const originalTotalCents = originalPerBottleCents * selectedQuantity;
          console.log('originalTotal: ', (originalTotalCents / 100).toFixed(2))

          const discountedTotalCents = calculateTotalPriceCentsFromUnit(
            originalPerBottleCents,
            selectedQuantity,
            selectedValue === 'subscribe'
          );
          console.log('discountedTotal: ', (discountedTotalCents / 100).toFixed(2))
          
          // Update both original and discounted prices
          originalPrice.textContent = formatMoneyFromCents(originalTotalCents);
          discountedPrice.textContent = formatMoneyFromCents(discountedTotalCents);
          
          if (originalTotalCents === discountedTotalCents) {
            originalPrice.classList.add('hidden');
          } else {
            originalPrice.classList.remove('hidden');
          }
        }
      }
    });
    
    // Update the total discount percentage for subscription
    const totalDiscountElement = document.querySelector('[data-total-discount]');
    if (totalDiscountElement) {
      // Calculate the percentage discount for subscription
      const originalPerBottleCents = baseUnitPriceCents;
      const subscriptionPerBottleCents = applyDiscountsToUnitPriceCents(originalPerBottleCents, selectedQuantity, true);
      
      // Calculate the percentage discount
      const discountPercentage = originalPerBottleCents > 0
        ? Math.round(((originalPerBottleCents - subscriptionPerBottleCents) / originalPerBottleCents) * 100)
        : 0;
      
      totalDiscountElement.textContent = `${discountPercentage}%`;
    }
    
    // Update the offer brand text
    const offerBrandTextElement = document.querySelector('[data-offer-brand-text]');
    if (offerBrandTextElement) {
      const subscriptionSelection = document.querySelector('input[name="subscription-type"]:checked');
      const isSubscription = subscriptionSelection && subscriptionSelection.value === 'subscribe';
      
      let brandText = '';
      
      if (isSubscription) {
        // Calculate subscription discount percentage
        const originalTotalCents = baseUnitPriceCents * selectedQuantity;
        const subscriptionTotalCents = calculateTotalPriceCentsFromUnit(baseUnitPriceCents, selectedQuantity, true);
        const subscriptionDiscount = originalTotalCents > 0
          ? Math.round(((originalTotalCents - subscriptionTotalCents) / originalTotalCents) * 100)
          : 0;
        
        if (selectedQuantity >= 3) {
          brandText = `Subscribe and Save - 3+ bags - Save ${subscriptionDiscount}%`;
        } else if (selectedQuantity === 2) {
          brandText = `Subscribe and Save - 2 bags - Save ${subscriptionDiscount}%`;
        } else {
          brandText = `Subscribe and Save - 1 bag - Save ${subscriptionDiscount}%`;
        }
      } else {
        // One-time purchase
        const originalTotalCents = baseUnitPriceCents * selectedQuantity;
        const oneTimeTotalCents = calculateTotalPriceCentsFromUnit(baseUnitPriceCents, selectedQuantity, false);
        
        if (originalTotalCents === oneTimeTotalCents) {
          // No discount for one-time purchase
          if (selectedQuantity === 1) {
            brandText = 'One Time Purchase - 1 Bag';
          } else if (selectedQuantity === 2) {
            brandText = 'One Time Purchase - 2 bags';
          } else {
            brandText = 'One Time Purchase - 3+ bags';
          }
        } else {
          // There is a discount for one-time purchase
          const oneTimeDiscount = originalTotalCents > 0
            ? Math.round(((originalTotalCents - oneTimeTotalCents) / originalTotalCents) * 100)
            : 0;
          if (selectedQuantity >= 3) {
            brandText = `One Time Purchase - 3+ bags - Save ${oneTimeDiscount}%`;
          } else if (selectedQuantity === 2) {
            brandText = `One Time Purchase - 2 bags - Save ${oneTimeDiscount}%`;
          } else {
            brandText = `One Time Purchase - 1 bag - Save ${oneTimeDiscount}%`;
          }
        }
      }
      
      offerBrandTextElement.textContent = brandText;
    }
  }

  // Add custom code below this line
  // Defer initialization until DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOffer1);
  } else {
    initOffer1();
  }

  const selectors = {
    qtySelectorBtn: "button",
    selectColorsBtn: '[data-select-colors]',
    selectColorsBtnContainer: '.select-colors-button-container',
    variantSelector: '.selector-wrapper--fullwidth',
    qtySelectGrid: '.quantity-selector-grid',
    bundleGiftImages: '.bundle-gift-image',
    bundleTitleHeadline: '.bundle-title__headline',
    bundleTitleDashedBox: '.bundle-title__dashed-box',
    bundleGiftDeadlineBox: '.bundle-gift-deadline-box'
  };

  class QtySelectGrid extends HTMLElement {
    constructor() {
      super();
      this.qtySelectBtns = this.querySelectorAll(selectors.qtySelectorBtn);
      this.selectColorsBtn = document.querySelector(selectors.selectColorsBtn);
      this.selectColorsBtnContainer = document.querySelector(selectors.selectColorsBtnContainer);
      this.variantSelector = document.querySelector(selectors.variantSelector);
      this.qtySelectGrid = document.querySelector(selectors.qtySelectGrid);
      this.bundleGiftImages = document.querySelectorAll(selectors.bundleGiftImages);
      this.bundleTitleHeadline = document.querySelector(selectors.bundleTitleHeadline);
      this.bundleTitleDashedBox = document.querySelector(selectors.bundleTitleDashedBox);
      this.bundleGiftDeadlineBox = document.querySelector(selectors.bundleGiftDeadlineBox);

      if (this.qtySelectBtns) {
        this.qtySelectBtns.forEach((btn) => {
          btn.addEventListener("click", this.toggleAriaSelected.bind(this));
          // btn.addEventListener("click", this.updatePriceComparison.bind(this));
          btn.addEventListener("click", this.updateBundleGiftBackgrounds.bind(this));
          // Add event listener to handle clicks on inner elements
          btn.addEventListener("click", (event) => {
            // Check if the target is not the button itself
            if (event.target !== btn) {
              btn.click(); // Trigger the button's click event
            }
          });
        });
      }

      // Initialize SELECT COLORS button functionality
      if (this.selectColorsBtn && this.variantSelector) {
        this.selectColorsBtn.addEventListener('click', () => {

           // Track Facebook pixel AddToCart event
           if (typeof fbq !== 'undefined') {
            // Get the selected quantity from the currently selected button
            const selectedButton = document.querySelector('.quantity-selector__card[aria-selected="true"]');
            const selectedQuantity = selectedButton ? parseInt(selectedButton.getAttribute('data-offer-qty'), 10) || 3 : 3;
            
            // Calculate value based on selected quantity and pricing tier
            const totalValueCents = calculateTotalPriceCentsFromUnit(
              getBaseUnitPriceCents(),
              selectedQuantity,
              isSubscriptionSelected()
            );
            
            fbq('track', 'AddToCart', {
              content_ids: '7412157513865',
              content_type: 'product',
              currency: "USD",
              value: totalValueCents / 100,
              content_name: 'EVOLV Hydrogen Water Bundle'
            });
            
            console.log('Facebook pixel AddToCart event tracked (SELECT COLORS):', {
              content_ids: '7412157513865',
              content_type: 'product',
              currency: "USD",
              value: totalValueCents / 100,
              selectedQuantity: selectedQuantity
            });
          }


          // Reset all quantity inputs to ensure clean state
          this.resetAllQuantityInputs();
          
          // Show variant selector
          this.variantSelector.classList.add('active');
          this.variantSelector.style.display = 'block';
          
          // Hide SELECT COLORS button and qty select grid
          if (this.selectColorsBtnContainer) {
            this.selectColorsBtnContainer.style.display = 'none';
          }
          if (this.qtySelectGrid) {
            this.qtySelectGrid.style.display = 'none';
          }

          // Hide other elements
          if (this.bundleTitleHeadline) this.bundleTitleHeadline.style.display = 'none';
          if (this.bundleTitleDashedBox) this.bundleTitleDashedBox.style.display = 'none';
          if (this.bundleGiftDeadlineBox) this.bundleGiftDeadlineBox.style.display = 'none';

          // Reset bundle gift backgrounds
          this.resetBundleGiftBackgrounds();
        });
      }

      // Sync the initial UI from whichever quantity card Liquid marked selected.
      this.resetBundleGiftBackgrounds();
      updateAllPricingDisplays();
    }

    updateBundleGiftBackgrounds(event) {
      const qty = parseInt(event.target.getAttribute('data-offer-qty'), 10) || 3;
      const giftItems = document.querySelectorAll('.bundle-gift-item');
      
      giftItems.forEach((item, idx) => {
        // Unlock logic: 1st gift (1+), 2nd (2+), 3rd (3+), 4th (3+)
        let isUnlocked = false;
        if (idx === 0 && qty >= 1) isUnlocked = true;
        if (idx === 1 && qty >= 2) isUnlocked = true;
        if (idx >= 2 && qty >= 3) isUnlocked = true;

        // Toggle .active class on the parent only
        if (isUnlocked) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    resetBundleGiftBackgrounds() {
      // Instead of removing all active classes, update based on current selection
      const selectedButton = document.querySelector('.quantity-selector__card[aria-selected="true"]');
      if (selectedButton) {
        this.updateBundleGiftBackgrounds({ target: selectedButton });
      }
    }

    toggleAriaSelected(event) {
      this.qtySelectBtns.forEach((btn) => {
        // const isSelected = event.target.getAttribute('aria-selected') === 'true';
        btn.setAttribute("aria-selected", "false");
      });
      event.target.setAttribute("aria-selected", "true"); // Set the clicked button as selected

      // Handle beginner deal tag and pricing for 1 bottle option
      // this.handleBeginnerDeal(event.target);

      // Get the selected quantity from the custom attribute
      const selectedQuantity =
        parseInt(event.target.getAttribute("data-offer-qty"), 10) || 0;

      // Dispatch a custom event with the selected quantity
      this.dispatchEvent(
        new CustomEvent("quantity-selected", {
          detail: { selectedQuantity: selectedQuantity },
          bubbles: true, // Allow the event to bubble up the DOM
          composed: true, // Allow the event to cross the shadow DOM boundary
        })
      );

      // Update all pricing displays
      updateAllPricingDisplays();
    }

    resetAllQuantityInputs() {
      const quantityInputs = this.querySelectorAll('input[type="number"]');
      quantityInputs.forEach((input) => {
        input.value = 0;
      });
    }
  }

  // Check if the custom element is already defined before defining it
  if (!customElements.get("qty-select-grid")) {
    customElements.define("qty-select-grid", QtySelectGrid);
  }

  const selectors$2 = {
    offerContainer: ".offer-container",
    addContainer: ".variant-qty__add",
    addBtn: ".variant-qty__add-btn",
    qtyCounter: ".quantity-counter",
    qtyInput: "input.quantity-field",
    qtyPlus: ".quantity-plus",
    qtyMinus: ".quantity-minus",
    checkoutBtn: "[data-proceed-to-checkout]",
    checkoutBtnText: ".btn__text",
    toGo: ".variants-qty__togo",
    offerFourImg: "[data-offer-four-img]",
  };

  const classes = {
    hidden: "hidden",
  };

  class VariantQtySelect extends HTMLElement {
    constructor() {
      super();
      this.addContainer = this.querySelectorAll(selectors$2.addContainer);
      this.addBtn = this.querySelectorAll(selectors$2.addBtn);
      this.qtyCounter = this.querySelectorAll(selectors$2.qtyCounter);
      this.qtyInput = this.querySelectorAll(selectors$2.qtyInput);
      this.qtyPlus = this.querySelectorAll(selectors$2.qtyPlus);
      this.qtyMinus = this.querySelectorAll(selectors$2.qtyMinus);
      this.checkoutBtn = this.querySelector(selectors$2.checkoutBtn);
      this.checkoutBtnText = this.querySelector(selectors$2.checkoutBtnText);
      this.toGo = this.querySelector(selectors$2.toGo);
      this.offerFourImg = this.querySelector(selectors$2.offerFourImg);
      this.offerContainer = document.querySelector(selectors$2.offerContainer);

      // Free gift product IDs and variant IDs
      // this.freeGifts = {
      //   ebook: {
      //     productId: 8107949621385,
      //     variantId: 43963811496073,
      //     title: "RESET YOUR BODY IN 14 DAYS: HYDROGEN WATER + FITNESS BLUEPRINT"
      //   },
      //   charger: {
      //     productId: 7822945157257,
      //     variantId: 42880089227401,
      //     title: "EVOLV Charging Block"
      //   },
      //   seals: {
      //     productId: 7654294388873,
      //     variantId: 42429205250185,
      //     title: "EVOLV Food-Grade Compression Seal"
      //   }
      // };

      // Get the selected quantity from the qty-select-grid
      this.selectedQuantity = 3; // Default to 3 bottles
      
      // Listen for quantity selection events from qty-select-grid
      document.addEventListener('quantity-selected', (event) => {
        this.selectedQuantity = event.detail.selectedQuantity;
        this.updateCheckoutBtn(this.updateTotalQuantity());
      });

      // Initialize bundle gift images
      this.bundleGiftImages = document.querySelectorAll('.bundle-gift-image');

      // Prevent caching of quantity inputs
      this.preventInputCaching();

      if (this.addBtn) {
        this.addBtn.forEach((btn) => {
          btn.addEventListener("click", this.showQtySelector.bind(this));
        });
      }

      if (this.qtyPlus) {
        this.qtyPlus.forEach((btn) => {
          btn.addEventListener("click", this.incrementQuantity.bind(this));
        });
      }

      if (this.qtyMinus) {
        this.qtyMinus.forEach((btn) => {
          btn.addEventListener("click", this.decrementQuantity.bind(this));
        });
      }

      if (this.qtyInput) {
        this.qtyInput.forEach((input) => {
          input.addEventListener("change", this.onQuantityChange.bind(this));
        });
      }

      // Initialize checkout button functionality
      if (this.checkoutBtn) {
        this.checkoutBtn.addEventListener('click', this.handleCheckout.bind(this));
      }

      // Set initial state
      this.updateCheckoutBtn(this.updateTotalQuantity());
      
      // Clear all quantities on page load
      this.clearAllQuantities();
      
      // Reset button state on page load to ensure it's not stuck in loading state
      this.resetButtonState();
      
      // Listen for SELECT COLORS button clicks to clear quantities
      document.addEventListener('click', (event) => {
        if (event.target.textContent.includes('SELECT COLORS') || 
            event.target.closest('[data-select-colors]')) {
          console.log('SELECT COLORS button clicked, clearing quantities...');
          this.clearAllQuantities();
        }
      });

      // Initialize subscription selection functionality
      this.initializeSubscriptionSelection();
      
      // Initialize subscription pricing on page load
      const defaultSubscription = document.querySelector('input[name="subscription-type"]:checked');
      if (defaultSubscription) {
        this.updateSubscriptionPricing(defaultSubscription.value);
        this.updateSelectColorsPricing(defaultSubscription.value);
      }
      
      // Observe for variant selector visibility changes
      const variantSelector = this.querySelector('.variants-qty-selector');
      if (variantSelector) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              if (variantSelector.style.display === 'block') {
                console.log('Variant selector shown, clearing quantities...');
                this.clearAllQuantities();
              }
            }
          });
        });
        
        observer.observe(variantSelector, { attributes: true });
      }

      // this.summaryRow = document.querySelector('.bundle-gifts-summary--select-colors');

      if (this.variantSelector && this.summaryRow) {
        const observer = new MutationObserver(() => {
          if (this.variantSelector.style.display === 'block') {
            this.summaryRow.style.display = 'flex';
          } else {
            this.summaryRow.style.display = 'none';
          }
        });
        observer.observe(this.variantSelector, { attributes: true, attributeFilter: ['style'] });
      }

      // Reset button state when page becomes visible (user navigates back)
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          console.log('Page became visible, resetting button state...');
          this.resetButtonState();
        }
      });

      // Reset button state on page load events
      document.addEventListener('page:load', () => {
        console.log('Page loaded, resetting button state...');
        this.resetButtonState();
      });

      // Reset button state on window focus (user returns to tab)
      window.addEventListener('focus', () => {
        console.log('Window focused, resetting button state...');
        this.resetButtonState();
      });

      // Reset button state on beforeunload (user is about to leave)
      window.addEventListener('beforeunload', () => {
        console.log('Page unloading, resetting button state...');
        this.resetButtonState();
      });
    }

    showQtySelector(event) {
      const addContainer = event.target.closest(selectors$2.addContainer);
      const qtyCounter = addContainer.querySelector(selectors$2.qtyCounter);
      const qtyInput = addContainer.querySelector(selectors$2.qtyInput);
      const addBtn = addContainer.querySelector(selectors$2.addBtn);

      if (qtyCounter && qtyInput && addBtn) {
        addBtn.classList.add(classes.hidden);
        qtyCounter.classList.remove(classes.hidden);
        qtyInput.value = 1;
        qtyInput.focus();
        this.updateCheckoutBtn(this.updateTotalQuantity());
        this.updatePricing(this.updateTotalQuantity());
        this.updateBundleGiftBackgrounds();
        if (this.summaryRow) this.summaryRow.style.display = 'flex';
      }
    }

    incrementQuantity(event) {
      const qtyInput = event.target.closest(selectors$2.qtyCounter).querySelector(selectors$2.qtyInput);
      if (qtyInput) {
        qtyInput.value = parseInt(qtyInput.value) + 1;
        this.checkQuantity(qtyInput);
        this.updateCheckoutBtn(this.updateTotalQuantity());
        this.updatePricing(this.updateTotalQuantity());
        this.updateBundleGiftBackgrounds();
      }
    }

    decrementQuantity(event) {
      const qtyInput = event.target.closest(selectors$2.qtyCounter).querySelector(selectors$2.qtyInput);
      if (qtyInput && parseInt(qtyInput.value) > 1) {
        qtyInput.value = parseInt(qtyInput.value) - 1;
        this.checkQuantity(qtyInput);
        this.updateCheckoutBtn(this.updateTotalQuantity());
        this.updatePricing(this.updateTotalQuantity());
        this.updateBundleGiftBackgrounds();
      } else if (qtyInput && parseInt(qtyInput.value) <= 1) {
        // Hide quantity counter and show add button
        const addContainer = event.target.closest(selectors$2.addContainer);
        const qtyCounter = addContainer.querySelector(selectors$2.qtyCounter);
        const addBtn = addContainer.querySelector(selectors$2.addBtn);
        
        if (qtyCounter && addBtn) {
          qtyCounter.classList.add(classes.hidden);
          addBtn.classList.remove(classes.hidden);
          qtyInput.value = 0;
        }
        this.updateCheckoutBtn(this.updateTotalQuantity());
        this.updatePricing(this.updateTotalQuantity());
        this.updateBundleGiftBackgrounds();
        
        // Only hide summary row if total quantity is 0 across all variants
        const totalQuantity = this.updateTotalQuantity();
        if (this.summaryRow) {
          this.summaryRow.style.display = totalQuantity > 0 ? 'flex' : 'none';
        }
      }
    }

    onQuantityChange(event) {
      this.checkQuantity(event.target);
      this.updateCheckoutBtn(this.updateTotalQuantity());
      this.updatePricing(this.updateTotalQuantity());
      this.updateBundleGiftBackgrounds();
      
      // Update summary row visibility based on total quantity
      const totalQuantity = this.updateTotalQuantity();
      if (this.summaryRow) {
        this.summaryRow.style.display = totalQuantity > 0 ? 'flex' : 'none';
      }
    }

    checkQuantity(qtyInput) {
      const value = parseInt(qtyInput.value);
      if (value < 0) {
        qtyInput.value = 0;
      }
    }

    updateTotalQuantity() {
      let totalQuantity = 0;
      this.qtyInput.forEach((input) => {
        totalQuantity += parseInt(input.value) || 0;
      });

      return totalQuantity; // Return the total quantity for further comparison
    }

    // getFreeGiftsForQuantity(totalQuantity) {
    //   const freeGifts = [];
    //   // 1 bottle -> include ebook
    //   if (totalQuantity >= 1) freeGifts.push(this.freeGifts.ebook);
    //   // 2 bottles -> include charger
    //   if (totalQuantity >= 2) freeGifts.push(this.freeGifts.charger);
    //   // 3 bottles or more -> include seals
    //   if (totalQuantity >= 3) {
    //     freeGifts.push(this.freeGifts.seals);
    //   }
    //   return freeGifts;
    // }

    updateCheckoutBtn(totalQuantity) {
      const bottlesToAdd = this.selectedQuantity - totalQuantity;
      const toGo = this.querySelector(selectors$2.toGo);

      if (this.checkoutBtn) {
        if (bottlesToAdd <= 0) {
          this.checkoutBtn.removeAttribute("disabled"); // Enable the button
          this.checkoutBtnText.textContent = "Proceed to Checkout"; // Change the button text
          if (toGo) toGo.textContent = "Offer unlocked!";
        } else {
          this.checkoutBtn.setAttribute("disabled", "disabled"); // Disable the button
          this.checkoutBtnText.textContent = `Select ${bottlesToAdd} more`; // Update the text to reflect current total
          if (toGo) toGo.textContent = `Add ${bottlesToAdd} more`;
        }
      }

      // Always show the toGo label in the header
      if (toGo) {
        toGo.classList.remove(classes.hidden);
      }
    }

    updatePricing(totalQuantity) {
      // NOTE: pricing display here was previously hardcoded to a single MSRP.
      // We now compute totals using each selected variant's `data-variant-price` in cents.
      const isSub = isSubscriptionSelected();
      const flatDiscountPerUnitCents = getFlatDiscountPerUnitCents(totalQuantity);

      let originalTotalCents = 0;
      let discountedTotalCents = 0;

      this.qtyInput.forEach((input) => {
        const qty = parseInt(input.value, 10) || 0;
        if (qty <= 0) return;

        const variantId = input.getAttribute('data-variant-id');
        const variantBtn = this.querySelector(`[data-variant-id="${variantId}"][data-variant-price]`);
        const variantPriceCents = parseInt(variantBtn?.getAttribute('data-variant-price') || '', 10) || 0;

        originalTotalCents += variantPriceCents * qty;

        let perUnitDiscountedCents = variantPriceCents;
        if (isSub) {
          perUnitDiscountedCents = Math.round((perUnitDiscountedCents * PRICING_CONFIG.SUBSCRIPTION_DISCOUNT_PERCENT) / 100);
        }
        perUnitDiscountedCents = Math.max(0, perUnitDiscountedCents - flatDiscountPerUnitCents);

        discountedTotalCents += perUnitDiscountedCents * qty;
      });

      // Calculate savings based on original total vs discounted total
      // const savingsCents = originalTotalCents - discountedTotalCents;

      // Update the new summary row (if present)
      // const totalSavingsEl = document.querySelector('.bundle-gifts-summary__savings');
      // if (totalSavingsEl) {
      //   totalSavingsEl.textContent = `You're saving ${formatMoneyFromCents(savingsCents)}`;
      // }
      // const giftsUnlockedBadge = document.querySelector('.bundle-gifts-summary__badge-text');
      // if (giftsUnlockedBadge) {
      //   // Count unlocked gifts based on visual logic: 1st gift (1+), 2nd (2+), 3rd & 4th (3+)
      //   let unlocked = 0;
      //   if (totalQuantity >= 1) unlocked++;
      //   if (totalQuantity >= 2) unlocked++;
      //   if (totalQuantity >= 3) unlocked += 2; // 3rd and 4th gifts unlocked at 3 bottles
      //   giftsUnlockedBadge.textContent = `GIFTS UNLOCKED: ${unlocked}/4`;
      // }
    }

    updateBundleGiftBackgrounds() {
      // Only update bundle gift backgrounds if the variant selector is visible
      // This prevents interference with the initial HTML state
      if (this.style.display === 'none' || this.style.display === '') {
        return; // Don't update if variant selector is hidden
      }
      
      const totalQuantity = this.updateTotalQuantity();
      const giftItems = document.querySelectorAll('.bundle-gift-item');
      giftItems.forEach((item, idx) => {
        // Unlock logic: 1st gift (1+), 2nd (2+), 3rd (3+), 4th (3+)
        let isUnlocked = false;
        if (idx === 0 && totalQuantity >= 1) isUnlocked = true;
        if (idx === 1 && totalQuantity >= 2) isUnlocked = true;
        if (idx >= 2 && totalQuantity >= 3) isUnlocked = true;

        // Toggle .active class on the parent only
        if (isUnlocked) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    handleCheckout(event) {
      event.preventDefault();
      
      // Show loading state immediately
      const loader = this.checkoutBtn.querySelector('.btn__loader');
      const text = this.checkoutBtn.querySelector('.btn__text');
      
      // Add loading class to button for styling
      this.checkoutBtn.classList.add('is-loading');
      this.checkoutBtn.setAttribute('disabled', 'disabled');
      
      if (loader) {
        loader.style.display = 'inline-block';
        loader.style.visibility = 'visible';
        // Position loader absolutely to overlay the text
        loader.style.position = 'absolute';
        loader.style.top = '50%';
        loader.style.left = '50%';
        loader.style.transform = 'translate(-50%, -50%)';
      }
      if (text) {
        text.style.visibility = 'hidden';
      }
      
      // Build cart items from the variant selector
      const cartItems = [];
      console.log('=== CHECKOUT DEBUG ===');
      console.log('Checking all quantity inputs:');
      
      this.qtyInput.forEach((input, index) => {
        const quantity = parseInt(input.value) || 0;
        const variantId = input.getAttribute('data-variant-id');
        const variantTitle = input.closest('.variants-qty-card')?.querySelector('span')?.textContent || 'Unknown';
        
        console.log(`Input ${index}: quantity=${quantity}, variantId=${variantId}, title="${variantTitle}"`);
        
        if (quantity > 0) {
          console.log(`✅ SELECTED: ${variantTitle} (Qty: ${quantity})`);
          
          if (variantId) {
            cartItems.push({
              id: variantId,
              quantity: quantity,
              title: variantTitle
            });
          } else {
            console.error('❌ No variant ID found on input:', input);
          }
        } else {
          console.log(`❌ NOT SELECTED: ${variantTitle}`);
        }
      });

      console.log('=== FINAL SELECTION ===');
      console.log(`Total items to checkout: ${cartItems.length}`);
      cartItems.forEach((item, index) => {
        console.log(`${index + 1}. ${item.title} - Qty: ${item.quantity} (ID: ${item.id})`);
      });
      console.log('======================');

      // Check subscription selection and add selling plan if needed
      const subscriptionSelection = document.querySelector('[data-subscription-selection]');
      if (subscriptionSelection) {
        const selectedSubscription = subscriptionSelection.querySelector('input[name="subscription-type"]:checked');
        if (selectedSubscription && selectedSubscription.value === 'subscribe') {
          console.log('✅ Subscription selected - adding selling plan to all items');
          cartItems.forEach(item => {
            if (!item.isFreeGift) { // Don't add selling plan to free gifts
              item.selling_plan = "5131960457";
            }
          });
        } else {
          console.log('✅ One-time purchase selected - no selling plan');
        }
      }

      if (cartItems.length === 0) {
        console.error('No items selected');
        // Reset button state
        this.resetButtonState();
        return;
      }

      // Calculate total bottle quantity and add free gifts
      // const totalBottleQuantity = cartItems.reduce((total, item) => total + item.quantity, 0);
      // const freeGifts = this.getFreeGiftsForQuantity(totalBottleQuantity);
      
      // Add free gifts to cart items
      // freeGifts.forEach(gift => {
      //   cartItems.push({
      //     id: gift.variantId,
      //     quantity: 1,
      //     title: gift.title,
      //     isFreeGift: true
      //   });
      // });

      console.log('=== FINAL CART WITH FREE GIFTS ===');
      // console.log(`Total bottle quantity: ${totalBottleQuantity}`);
      // console.log(`Free gifts added: ${freeGifts.length}`);
      cartItems.forEach((item, index) => {
        const giftIndicator = item.isFreeGift ? ' (FREE GIFT)' : '';
        console.log(`${index + 1}. ${item.title}${giftIndicator} - Qty: ${item.quantity} (ID: ${item.id})`);
      });
      console.log('==================================');

      // Get discount code
      const discountCodeInput = this.offerContainer.querySelector('[data-discount-code-input]');
      const discountCode = discountCodeInput ? discountCodeInput.value : null;

      console.log('Discount code:', discountCode);

      // Use direct checkout URL
      this.createDirectCheckoutURL(cartItems, discountCode);
    }

    resetButtonState() {
      if (!this.checkoutBtn) return;
      
      const loader = this.checkoutBtn.querySelector('.btn__loader');
      const text = this.checkoutBtn.querySelector('.btn__text');
      
      // Remove loading class from button
      this.checkoutBtn.classList.remove('is-loading');
      this.checkoutBtn.removeAttribute('disabled');
      
      // Reset loader visibility and positioning
      if (loader) {
        loader.style.display = 'none';
        loader.style.visibility = 'hidden';
        loader.style.position = '';
        loader.style.top = '';
        loader.style.left = '';
        loader.style.transform = '';
      }
      
      // Reset text visibility
      if (text) {
        text.style.visibility = 'visible';
        text.style.display = '';
      }
      
      // Update checkout button text based on current state
      const totalQuantity = this.updateTotalQuantity();
      const bottlesToAdd = this.selectedQuantity - totalQuantity;
      
      if (bottlesToAdd <= 0) {
        if (text) text.textContent = "Proceed to Checkout";
        this.checkoutBtn.removeAttribute("disabled");
      } else {
        if (text) text.textContent = `Select ${bottlesToAdd} more`;
        this.checkoutBtn.setAttribute("disabled", "disabled");
      }
      
      console.log('Button state reset completed');
    }



    createDirectCheckoutURL(cartItems, discountCode) {
      console.log('Cart items to add:', cartItems);
      
      // Clear any cart-related storage
      try {
        if (typeof localStorage !== 'undefined') {
          localStorage.removeItem('cart');
          localStorage.removeItem('cart_token');
          localStorage.removeItem('shopify_cart');
          localStorage.removeItem('cart_attributes');
        }
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.removeItem('cart');
          sessionStorage.removeItem('cart_token');
          sessionStorage.removeItem('shopify_cart');
          sessionStorage.removeItem('cart_attributes');
        }
      } catch (e) {
        console.log('Could not clear storage:', e);
      }
      
      // First clear the cart using AJAX, then redirect
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart cleared successfully:', data);
        
        // Build the cart/add URL
        let checkoutUrl = '/cart/add?';
        
        // Add items using the correct Shopify format
        cartItems.forEach((item, index) => {
          if (index > 0) checkoutUrl += '&';
          checkoutUrl += `items[${index}][id]=${item.id}&items[${index}][quantity]=${item.quantity}`;
          if (item.selling_plan) {
            checkoutUrl += `&items[${index}][selling_plan]=${item.selling_plan}`;
          }
        });
        
        // Add discount code if present
        if (discountCode) {
          checkoutUrl += `&discount=${encodeURIComponent(discountCode)}`;
        }
        
        // Add return to checkout
        checkoutUrl += '&return_to=/checkout';
        
        console.log('Direct checkout URL:', checkoutUrl);
        
        // Navigate to checkout
        window.location.href = checkoutUrl;
      })
      .catch(error => {
        console.error('Error clearing cart:', error);
        
        // Fallback: try direct checkout without clearing
        let checkoutUrl = '/cart/add?';
        
        cartItems.forEach((item, index) => {
          if (index > 0) checkoutUrl += '&';
          checkoutUrl += `items[${index}][id]=${item.id}&items[${index}][quantity]=${item.quantity}`;
          if (item.selling_plan) {
            checkoutUrl += `&items[${index}][selling_plan]=${item.selling_plan}`;
          }
        });
        
        if (discountCode) {
          checkoutUrl += `&discount=${encodeURIComponent(discountCode)}`;
        }
        
        checkoutUrl += '&return_to=/checkout';
        
        console.log('Fallback checkout URL:', checkoutUrl);
        window.location.href = checkoutUrl;
      });
    }

    showCartDebugInfo(cartData, discountCode) {
      // Reset button state
      this.resetButtonState();

      // Create debug container if it doesn't exist
      let debugContainer = document.querySelector('.cart-debug-container');
      if (!debugContainer) {
        debugContainer = document.createElement('div');
        debugContainer.className = 'cart-debug-container';
        debugContainer.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          width: 400px;
          max-height: 80vh;
          background: white;
          border: 2px solid #007cba;
          border-radius: 8px;
          padding: 20px;
          z-index: 9999;
          overflow-y: auto;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          font-family: monospace;
          font-size: 12px;
        `;
        document.body.appendChild(debugContainer);
      }

      // Clear existing content
      debugContainer.innerHTML = '';

      // Add title
      const title = document.createElement('h3');
      title.textContent = '🛒 Cart Debug Info';
      title.style.cssText = 'margin: 0 0 15px 0; color: #007cba; font-size: 16px;';
      debugContainer.appendChild(title);

      // Add cart data
      const cartInfo = document.createElement('div');
      cartInfo.innerHTML = `
        <strong>Cart Items (${cartData.items ? cartData.items.length : 0}):</strong><br>
        <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin: 10px 0; white-space: pre-wrap;">${JSON.stringify(cartData.items, null, 2)}</pre>
        
        <strong>Cart Total:</strong> $${cartData.total_price ? (cartData.total_price / 100).toFixed(2) : 'N/A'}<br>
        <strong>Item Count:</strong> ${cartData.item_count || 0}<br>
        <strong>Discount Code:</strong> ${discountCode || 'None'}<br>
        
        ${cartData.discount_applications ? `
        <strong>Discount Applications:</strong><br>
        <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin: 10px 0; white-space: pre-wrap;">${JSON.stringify(cartData.discount_applications, null, 2)}</pre>
        ` : ''}
        
        <strong>Full Cart Object:</strong><br>
        <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin: 10px 0; white-space: pre-wrap; max-height: 200px; overflow-y: auto;">${JSON.stringify(cartData, null, 2)}</pre>
      `;
      debugContainer.appendChild(cartInfo);

      // Add redirect button
      const redirectBtn = document.createElement('button');
      redirectBtn.textContent = '🚀 Redirect to Checkout';
      redirectBtn.style.cssText = `
        background: #007cba;
        color: white;
        border: none;
        padding: 12px 20px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        margin-top: 15px;
        width: 100%;
      `;
      redirectBtn.addEventListener('click', () => {
        if (discountCode) {
          window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
        } else {
          window.location.href = '/checkout';
        }
      });
      debugContainer.appendChild(redirectBtn);

      // Add direct checkout URL button (alternative approach)
      const directCheckoutBtn = document.createElement('button');
      directCheckoutBtn.textContent = '🔗 Direct Checkout URL';
      directCheckoutBtn.style.cssText = `
        background: #28a745;
        color: white;
        border: none;
        padding: 12px 20px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        margin-top: 10px;
        width: 100%;
      `;
      directCheckoutBtn.addEventListener('click', () => {
        // Build direct checkout URL that bypasses cart entirely
        const items = cartData.items.map(item => `${item.id}:${item.quantity}`).join(',');
        let checkoutUrl = `/cart/${items}`;
        
        // Add discount code if provided
        if (discountCode) {
          checkoutUrl += `?discount=${encodeURIComponent(discountCode)}`;
        }
        
        console.log('Direct checkout URL (bypassing cart):', checkoutUrl);
        // window.location.href = checkoutUrl;
      });
      debugContainer.appendChild(directCheckoutBtn);

      // Add close button
      const closeBtn = document.createElement('button');
      closeBtn.textContent = '❌ Close Debug';
      closeBtn.style.cssText = `
        background: #dc3545;
        color: white;
        border: none;
        padding: 8px 15px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 12px;
        margin-top: 10px;
        width: 100%;
      `;
      closeBtn.addEventListener('click', () => {
        debugContainer.remove();
      });
      debugContainer.appendChild(closeBtn);

      console.log('Cart debug info displayed. Check the debug panel in the top-right corner.');
    }

    resetAllQuantityInputs() {
      this.qtyInput.forEach((input) => {
        input.value = 0;
        // Also reset the UI state for each input
        const addContainer = input.closest(selectors$2.addContainer);
        const qtyCounter = addContainer.querySelector(selectors$2.qtyCounter);
        const addBtn = addContainer.querySelector(selectors$2.addBtn);
        
        if (qtyCounter && addBtn) {
          qtyCounter.classList.add(classes.hidden);
          addBtn.classList.remove(classes.hidden);
        }
      });
      
      // Reset pricing and checkout button state
      this.updateCheckoutBtn(this.updateTotalQuantity());
      this.updatePricing(this.updateTotalQuantity());
      this.updateBundleGiftBackgrounds();
    }

    // Prevent caching of quantity inputs
    preventInputCaching() {
      this.qtyInput.forEach((input) => {
        // Set autocomplete to off
        input.setAttribute('autocomplete', 'off');
        
        // Add additional attributes to prevent caching
        input.setAttribute('data-lpignore', 'true');
        input.setAttribute('data-form-type', 'other');
        
        // Clear value on focus to prevent autofill
        input.addEventListener('focus', () => {
          if (input.value === '0' || input.value === '') {
            input.value = '';
          }
        });
        
        // Clear value on page load
        input.addEventListener('DOMContentLoaded', () => {
          input.value = '0';
        });
        
        // Clear value when window loads
        input.addEventListener('load', () => {
          input.value = '0';
        });
        
        // Prevent browser autofill
        input.addEventListener('input', (e) => {
          // Ensure only numbers are entered
          const value = e.target.value.replace(/[^0-9]/g, '');
          e.target.value = value;
        });
      });
      
      // Also clear on window load
      window.addEventListener('load', () => {
        this.clearAllQuantities();
      });
      
      // Clear on page visibility change (when user returns to tab)
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          this.clearAllQuantities();
        }
      });
    }

    // Clear all quantities on page load
    clearAllQuantities() {
      this.qtyInput.forEach((input) => {
        input.value = 0;
        // Also reset the UI state for each input
        const addContainer = input.closest(selectors$2.addContainer);
        const qtyCounter = addContainer.querySelector(selectors$2.qtyCounter);
        const addBtn = addContainer.querySelector(selectors$2.addBtn);
        
        if (qtyCounter && addBtn) {
          qtyCounter.classList.add(classes.hidden);
          addBtn.classList.remove(classes.hidden);
        }
      });
      
      // Reset pricing and checkout button state
      this.updateCheckoutBtn(this.updateTotalQuantity());
      this.updatePricing(this.updateTotalQuantity());
      this.updateBundleGiftBackgrounds();
    }

    initializeSubscriptionSelection() {
      const subscriptionOptions = document.querySelectorAll('input[name="subscription-type"]');
      
      subscriptionOptions.forEach(option => {
        option.addEventListener('change', (event) => {
          const selectedValue = event.target.value;
          console.log('Subscription selection changed:', selectedValue);
          
          // Update UI to reflect selection
          const allLabels = document.querySelectorAll('.subscription-label');
          allLabels.forEach(label => {
            label.style.borderColor = '#e5e7eb';
            label.style.background = 'white';
          });
          
          const selectedLabel = event.target.closest('.subscription-option').querySelector('.subscription-label');
          if (selectedLabel) {
            selectedLabel.style.borderColor = '#207742';
            selectedLabel.style.background = '#f0f9f4';
          }

          // Update subscription pricing display
          // this.updateSubscriptionPricing(selectedValue);
          
          // Update all pricing displays
          updateAllPricingDisplays();
        });
      });
    }
  }

  customElements.define("variant-qty-selector", VariantQtySelect);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  // Function to handle offer-1 specific functionality
  function initOffer1() {
    const offerContainer = document.querySelector('[data-offer-1-container]');
    if (!offerContainer) return;

    // The checkout functionality is now handled directly in the VariantQtySelect class
    // No additional initialization needed here
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOffer1);
  } else {
    initOffer1();
  }

  // Also initialize on Shopify's page:load event for dynamic page changes
  document.addEventListener('page:load', initOffer1);

  // Centralized step state management for offer steps
  window.setOfferStep = function(step) {
    const qtySelectGrid = document.querySelector('.quantity-selector-grid');
    const subscriptionSelectionContainer = document.querySelector('.subscription-selection-container');
    const selectColorsBtnContainer = document.querySelector('.select-colors-button-container');
    const variantSelector = document.querySelector('variant-qty-selector');
    // const bundleGiftsSection = document.querySelector('[data-bundle-gifts-section]');
    const variantsQtyContainer = document.querySelector('.variants-qty-container');
    const summaryRow = document.querySelector('.bundle-gifts-summary--select-colors');
    const bundleTitleHeadline = document.querySelector('.bundle-title__headline');
    const bundleTitleDashedBox = document.querySelector('.bundle-title__dashed-box');
    const bundleGiftDeadlineBox = document.querySelector('.bundle-gift-deadline-box');

    if (step === 1) {
      if (qtySelectGrid) qtySelectGrid.style.display = '';
      if (subscriptionSelectionContainer) subscriptionSelectionContainer.style.display = '';
      if (selectColorsBtnContainer) selectColorsBtnContainer.style.display = '';
      if (variantSelector) variantSelector.style.display = 'none';
      if (summaryRow) summaryRow.style.display = 'none';
      if (bundleTitleHeadline) bundleTitleHeadline.style.display = '';
      if (bundleTitleDashedBox) bundleTitleDashedBox.style.display = '';
      if (bundleGiftDeadlineBox) bundleGiftDeadlineBox.style.display = '';
      // Move bundle gifts section back to original place (before select-colors-button-container)
      // if (bundleGiftsSection && selectColorsBtnContainer) {
      //   selectColorsBtnContainer.parentNode.insertBefore(bundleGiftsSection, selectColorsBtnContainer);
      // }
    } else if (step === 2) {
      if (qtySelectGrid) qtySelectGrid.style.display = 'none';
      if (subscriptionSelectionContainer) subscriptionSelectionContainer.style.display = 'none';
      if (selectColorsBtnContainer) selectColorsBtnContainer.style.display = 'none';
      if (variantSelector) variantSelector.style.display = 'block';
      if (summaryRow) summaryRow.style.display = 'flex';
      if (bundleTitleHeadline) bundleTitleHeadline.style.display = 'none';
      if (bundleTitleDashedBox) bundleTitleDashedBox.style.display = 'none';
      if (bundleGiftDeadlineBox) bundleGiftDeadlineBox.style.display = 'none';
      // Move bundle gifts section after variants-qty-container
      // if (bundleGiftsSection && variantsQtyContainer) {
      //   variantsQtyContainer.parentNode.insertBefore(bundleGiftsSection, variantsQtyContainer.nextSibling);
      // }
    }
  };
})();
